import React from 'react'
import { dispatch } from '@rematch/core';
import { source } from 'react-aim';
import IssueLogsCard from './IssueCard';

@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext(props.name)
    }
})
class Issue extends React.Component {
    render() {
        let issues;

        if (this.props.issues && this.props.issues.length > 0) {
            issues = this.props.issues && this.props.issues.map((item, i) => {
                return <IssueLogsCard item={item} index={i} key={i} />
            })
        } else {
            issues = "No Issues Found"
        }

        return (
            <div>
                {issues}
            </div>
        )
    }
}

export default Issue